import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingComponent } from '../../shared/loading/loading.component';

@Component({
  selector: 'app-in-navigation-placeholder',
  imports: [CommonModule, LoadingComponent],
  templateUrl: './in-navigation-placeholder.component.html',
  styleUrls: ['./in-navigation-placeholder.component.scss']
})
export class InNavigationPlaceholderComponent {
  protected readonly isLoggedIn = !!localStorage.getItem('zeva_signed_in');
}
